import { formatNumber } from './format_number';
export function formatCurrency(value, options = { currency: 'CLP' }) { return formatNumber(value, { ...options, style: 'currency' }); }
